module.exports = __webpack_public_path__ + "static/ranking_list_bac.6aa7de99.jpg";